import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface AppliedJobAnswer {
  questionId: string;
  question: string;
  answer: string;
  displayOrder: number;
}

export interface AppliedJobStatistics {
  totalApplications: number;
  interviews: number;
  acceptanceRate: number;
  activeApplications: number;
}

export interface AppliedJobApiItem {
  id: string;
  jobPostId: string;
  positionTitle: string;
  companyName: string;
  companyLogoUrl?: string;
  userId: string;
  applicantName: string;
  applicantEmail: string;
  applicantProfileLink: string | null;
  cvUrl: string;
  answers: AppliedJobAnswer[] | null;
  status: string;
  notes: string | null;
  appliedAt: string;
  updatedAt: string;
  interviewUrl: string;
  interviewExpirationDate?: string | null;
  interviewExpired?: boolean;
  jobPostTitle?: string;
}

export interface AppliedJobsPage {
  content: AppliedJobApiItem[];
  totalElements: number;
  totalPages: number;
  totalCount?: number;
  total?: number;
  size: number;
  number: number;
  first: boolean;
  last: boolean;
  numberOfElements: number;
  empty: boolean;
}

export interface AppliedJobsResponse {
  statistics: AppliedJobStatistics;
  jobs: AppliedJobsPage; // ✅ was AppliedJobApiItem[]
}

export interface AppliedJobsFilter {
  jobType?: string;
  status?: string;
  appliedAt?: string;
}

@Injectable({ providedIn: 'root' })
export class AppliedJobsService {
  constructor(private http: HttpClient) {}

  getMyApplications(
    page = 0,
    size = 10,
    filters: AppliedJobsFilter = {},
  ): Observable<AppliedJobsResponse> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString());

    if (filters.jobType) params = params.set('jobType', filters.jobType);
    if (filters.status) params = params.set('status', filters.status);
    if (filters.appliedAt) params = params.set('appliedAt', filters.appliedAt);

    return this.http.get<AppliedJobsResponse>(
      `${environment.apiUrl}api/job-applications/my`,
      { params },
    );
  }
}
